import { Box, Grid, Stack, Typography } from '@mui/material'
import CardTitle from './cardTitle';
import ClickableCard from '../../common/clickableCard';
import SkeletonCard from '../../common/skeletonCard';
import custom from '../../../styles/mui/szVariables.json'

export default function HotwaterCard({ 
        id, color, content, handleCardClick }: any) {

    if(!content) return (
        <SkeletonCard height="144px"/>
    )
    return (
        <ClickableCard
                id={id}
                height="144px"
                px={custom.spacing.sm}
                py={custom.spacing.sm}
                handleCardClick={ ()=>handleCardClick(true)}
            >
             <Grid container direction="column" 
                    justifyContent="start" 
                    alignItems="flex-left" >
                <Grid item>
                    <CardTitle icon={content.icon} 
                                cardTitle={content.cardTitle}
                                hoverIcon={content.hoverIcon}
                                id={id}  />
                </Grid>
                <Grid item mt={custom.spacing.xl}>
                    <Stack alignItems="start" direction="row" >
                        <Box>
                            <Typography variant='szHeading.Bold.Large' 
                                        id='hotwaterStateText' >
                                {content.state}
                            </Typography>
                            <Typography component="p" 
                                id='energySavingModeText'
                                sx={{ color: 'text.primary'}}
                                variant="szBody.Regular.Small" >
                                {content.desc}
                            </Typography>
                        </Box>
                        <Box component={"img"} id="hotwaterStateIcon"
                                ml="auto" 
                                mt={"20px"} 
                                p={custom.spacing.xxxxs}    
                                alt="extra icon"
                                height="24px"
                                src={`${content.extraIcon}${content.extraName ||''}`}
                                sx={{ backgroundColor: content.extraColor, 
                                      borderRadius: custom.corners5 
                                    }}
                            /> 
                    </Stack>
                </Grid>
            </Grid>  
        </ClickableCard>
    )
}